
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre-nos",
      function () {
        return require("private-next-pages/sobre-nos/index.js");
      }
    ]);
  